import { z } from 'zod';

export const declarationViewDV1Schema = z.object({
  dv1: z.object({
    seller: z.object({
      header: z.boolean().optional().nullable(),
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
    buyer: z.object({
      header: z.boolean().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      name: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
    contract: z.object({
      contractNumber: z.string().optional().nullable(),
      contractDate: z.string().optional().nullable(),
    }),
    BuyerSellerRelation: z.object({
      relation: z.string().optional().nullable(),
    }),
    RestrictionsAndConditions: z.object({
      restrictions: z.string().optional().nullable(),
      consideration: z.string().optional().nullable(),
      resale: z.string().optional().nullable(),
    }),
    RoyaltiesAndResale: z.object({
      royalties: z.string().optional().nullable(),
    }),
    signature: z.object({
      place: z.string().optional().nullable(),
    }),
  }),
});

export type DeclarationViewDV1FormValues = z.infer<typeof declarationViewDV1Schema>;
